/* tslint:disable:indent */
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidationMessages } from 'src/app/modules/shared/models/component-messages/validation-messages';
import { AvisExtractorService } from '../../../../formulaires/common/services/avis-extractor.service';
import { FormulaireServiceService } from '../../../../formulaires/services/formulaire-service.service';
import { FormExtractorService } from '../../../../shared/services/form-extractor.service';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';




@Component({
  selector: 'app-stepper-valider-demande',
  templateUrl: './valider-demande.component.html',
  styleUrls: ['./valider-demande.component.scss']
})
export class ValiderDemandeComponent implements OnInit {

  public validerMessage = new ValidationMessages();


  backErrors: any;
  @Input() onModification = false;
  @Input() referenceAvis;
  @Input() avisId;
  @Input() critereId;
  @Input() form: FormGroup;
  @Input() formulaireIntitule: string;
  @Input() formulaireCategory: string;


  constructor(private formulaireServiceService: FormulaireServiceService,
    private avisExtractorService: AvisExtractorService,
    public formExtractorService: FormExtractorService,
    private canNavigateInStepperService: CanNavigateInStepperService) {

  }
  public ngOnInit() {
    this.avisExtractorService._backErrorsBs.subscribe(data => {
      this.backErrors = data;
    });
  }
}

